var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floater"},[_c('label-preview',{attrs:{"label":_vm.label,"previewEndpoint":_vm.previewEndpoint,"validate":_vm.validate}}),_c('b-button',{attrs:{"variant":"primary","disabled":!_vm.canPrint},on:{"click":_vm.printLabel}},[_vm._v(" Print ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }